import { FC } from 'react'
import { businessBankingStrings } from 'common/strings/business-banking-strings'
import { Format } from 'common/utils/format'

type Props = {}

const TideExclusiveBusinessPartner: FC<Props> = () => {
  return (
    <div
      className='d-flex flex-column text-center mx-auto'
      style={{
        maxWidth: 930,
      }}
    >
      <h2 className='fs-fluid-36-80 fw-semibold mb-6 mb-lg-9 lh-105'>
        Tide is our exclusive <br className='d-none d-lg-block' /> business
        banking partner.
      </h2>
      <span className='fs-fluid-18-24 fs-lg-22 fw-semibold lh-119 lh-lg-132'>
        To benefit from the {businessBankingStrings.tideCashBackAmount} cashback
        reward, make sure to credit your new Tide account with a minimum{' '}
        {Format.moneyShort(100)} within 3 months of account opening.
      </span>
      <p className='fs-fluid-18-20 lh-119 lh-lg-140 pt-6 pt-lg-6 px-lg-13'>
        Tide is not a bank, but a business banking platform and the leading
        digital challenger in business banking services. See the full offer T&Cs
        below for further details. Transfers to non-Tide accounts are for 20p
        per transfer.
        <br />
        <br />
        Tide offers bank accounts provided by ClearBank. ClearBank Ltd is
        Authorised by the Prudential Regulation Authority and regulated by the
        Financial Conduct Authority and the Prudential Regulation Authority
        (Financial Services Register number: 754568). Registered Address: 4th
        Floor, Prologue Works, 25 Marsh Street, Bristol, England, BS1 4AX.
      </p>
      <span className='text-center mt-4'>
        <a
          href='https://www.tide.co/partners/hoxton-mix/?utm_source=webpage&utm_medium=webpage'
          className='color-pink2 fw-bold text-decoration-none'
        >
          Click here{' '}
        </a>
        for the Offer T&C’s
      </span>
    </div>
  )
}

export default TideExclusiveBusinessPartner
